import { merge, cloneDeep } from 'lodash-es'
import type { ThemeDefinition } from 'vuetify'
import { PRIMARY, PASTEL, SECONDARY, TERTIARY, OTHER, flattenObject } from './colors'

const surface = {
  bg: {
    primary: SECONDARY.white,
    secondary: SECONDARY.putty,
    invert: SECONDARY.slate,
  },
  elevated: {
    primary: SECONDARY.putty,
    secondary: SECONDARY.white,
  },
}
const type = {
  primary: SECONDARY.charcoal,
  secondary: SECONDARY.slate,
  invert: SECONDARY.white,
  subtle: SECONDARY.pebble,
}
const icon = {
  fill: {
    eucalyptus: TERTIARY.eucalyptus,
    mauve: TERTIARY.mauve,
    waterspout: TERTIARY.waterspout,
    peach: TERTIARY.peach,
    skyblue: TERTIARY.skyblue,
    topaz: TERTIARY.topaz,
  },
  stroke: {
    primary: SECONDARY.charcoal,
    invert: SECONDARY.white,
  },
}
const stroke = {
  primary: SECONDARY.charcoal,
  secondary: SECONDARY.pebble,
  invert: SECONDARY.white,
}
const btn = {
  primary: {
    default: SECONDARY.sunglow,
    hover: SECONDARY.sunglowLight,
  },
  secondary: SECONDARY.charcoal,
  ghost: {
    inverted: SECONDARY.sunglow,
  },
  danger: {
    default: OTHER.red,
    hover: OTHER.redLight,
  },
}
const on = {
  btn: {
    primary: {
      default: SECONDARY.charcoal,
    },
    secondary: SECONDARY.charcoal,
  },
}
const base = {
  black: '#000',
  white: '#fff',
  error: OTHER.red,
  success: OTHER.green,
  warning: OTHER.yellow,
  info: OTHER.blue,
  surface,
  type,
  icon,
  stroke,
  btn,
  on,
}

const vars = {}

export const consumer = <ThemeDefinition>{
  dark: false,
  colors: flattenObject(merge(cloneDeep(base), {
    surface: {
      bg: {
        accent: PRIMARY.teal,
      },
      elevated: {
        1: PRIMARY.teal,
        2: PASTEL.teal,
        3: PRIMARY.warmPlum,
        4: PASTEL.plum,
      },
    },
    type: {
      interactive: PRIMARY.teal,
    },
    link: {
      primary: PRIMARY.teal,
      invert: PRIMARY.lime,
    },
    btn: {
      ghost: {
        default: PRIMARY.teal,
      },
    },
  })),
  variables: vars,
}

export const pro = <ThemeDefinition>{
  dark: false,
  colors: flattenObject(merge(cloneDeep(base), {
    surface: {
      bg: {
        accent: PRIMARY.richPurple,
      },
      elevated: {
        1: PRIMARY.richPurple,
        2: PASTEL.purple,
        3: PRIMARY.arcticBlue,
        4: PASTEL.blue,
        5: PRIMARY.cobaltBlue,
        6: PASTEL.cobalt,
      },
    },
    type: {
      interactive: PRIMARY.richPurple,
    },
    link: {
      primary: PRIMARY.richPurple,
      invert: PRIMARY.arcticBlue,
    },
    btn: {
      ghost: {
        default: PRIMARY.richPurple,
      },
    },
  })),
  variables: vars,
}
